export class BiUrls {


    // Operations
    static GET_OPERATIONS_FOR_USER: string = 'hub/getBIUserOperations';

    // Roles
    static BIADMIN: string = 'biAdmin';


    // BI-ADMIN
    static CUBE: string = 'cube';
    static DIMENSION: string = 'dimension';
    static BI_DIMENSION: string = 'bi/dimension';
    static MEASURE: string = 'measure';
    static BI_MEASURE: string = 'bi/measure';

    static DATASOURCE: string = 'ds';
    static DATAENGINE: string = 'de';
    static UOM: string = 'uom';
    static SCOPE: string = 'scope';
    static RECORDFORMAT: string = 'recordFormat';
    static VALUESTREAM: string = 'vs';
    static DIM_LVL_PERMISSION: string = 'dimension/empOrgDimRel';
    static TARGET: string = 'target';
    static TENANT_CONFIG: string = 'tc';
    static CACHE: string = 'cache';
    static ANALYTICAL_SERVICE: string = 'adhoc';

    static PAGE: string = 'page';

    static DASHBOARD_PAGES: string = 'page/type/dashboard';
    static ALL_DASHBOARDS: string = 'page/allDashboards';

    

    // Search
    static SEARCH: string = '/search/';
    static SEARCH_P_CUBE: string = '/searchPCube?cubeReg=';
    static SEARCH_P_DIMENSION: string = '/searchPDim?dimRegex=';
    static SEARCH_DIMENSION: string = '/searchDim?dimRegex=';
    static SEARCH_P_MEASURE: string = '/searchPMeasure?measureRegex=';
    static SEARCH_P_UOM: string = '/searchPUom?uomReg=';
    static SEARCH_P_SCOPE: string = '/searchPScope?scopeReg=';
    static SEARCH_P_DATASOURCE: string = '/searchPDataSource?dataSourceReg=';
    static SEARCH_P_DATAENGINE: string = '/searchPDataEngine?dataEngineReg=';
    static SEARCH_P_RECORDFORMAT: string = '/searchPRecordFormat?recordFormatReg=';
    static SEARCH_P_VALUESTREAM: string = '/searchPValueStream?valueStreamReg=';
    static SEARCH_P_TARGET: string = '/searchPTarget?trgReg=';

    // BulkUpload
    static BULKUPLOAD_PAGE_AUTH: string = '/authorization/bulkUpload';
    static BULKUPLOAD_DIM_LVL_PERMISSION: string = '/empOrgDimRelation/bulkUpload';
    static BULKUPLOAD_TARGET: string = '/bulkUpload';

    // Miscellaneous
    static MEASURES_BY_CUBEMEASURES: string = '/getAllByCubeMeasure';
    static DIMENSION_BY_MEASURES: string = '/getDimensions/';
    static GET_ROLES: string = '/getRoles';
    static GET_ROLES_BY_EMP_INFO: string = '/getUsrRoleRelByEmpInfo';
    static ALL_P_EMPLOYEES: string = '/allPEmployee';
    static GET_ENGINE_BY_TYPE: string = '/type/';
    static GET_SECTIONS_BY_PAGE: string = '/sections';
    static TEST_CONNECTION: string = '/testConnection';
    static GET_PAGE_AUTH_BY_USER_AND_PAGE: string = '/pageAuthFrUsrs?pageId=';
    static GET_PAGE_AUTH_BY_ROLE: string = '/authorizationByRole';
    static GET_ALL : string = '/getAll';
    static SAVE_ROLE_AUTH: string = '/save';
    static REMOVE_ROLE_AUTH: string = '/remove';
    static GET_ALL_WIDGET : string = '/getWidgetsCount';
    static SAVE_MULTIPLE_PAGE_AUTH: string = '/pageAuth/saveMultiple';
    static GET_P_MAS_TRGS: string = 'target/paginatedMasTrgs/';
    static GET_TRGS_WITHOUT_HIERARCHY: string = 'target/withoutHierarchy/';
    static REMOVE_MULTIPLE_DIM_LVL_PERMSSIONS: string = '/removeMultipleEmpOrgDimRel';
    static SYNC_DATASOURCE: string = 'ads/sync/';
    static SYNC_ALL_RF_DATASOURCE: string = 'ads/syncAll/rf/';
    static SYNC_RECORD_FORMAT: string = 'ads/sync/rf/';
    static GET_DIM_LVL_VALUE: string = 'ads/dimension';
    static UPLOAD_DRILL_FILE: string = 'ads/uploadDrillFile';
    static REUPLOAD_DRILL_FILE: string = 'ads/reUploadFile';
    static DOWNLOAD_DRILL_FILE: string = 'ads/downloadFile';
    static NEW_ANALYTICAL_MODEL: string = 'ads/analyticalMod/new';
    static NEW_ANALYTICAL_MODEL_PRESTO: string = 'ads/analyticalMod/';
    static MATERIALIZED_PRESTO: string = 'ads/analyticalMod/newMaterialized/presto';
    static STARSCHEMA_PRESTO: string = 'ads/analyticalMod/newStarSchema/presto';
    static SAVE_ANALYTICAL_MODEL: string = 'ads/analyticalMod/save';
    static EDIT_ANALYTICAL_MODEL: string = 'ads/analyticalMod/edit';
    static UPDATE_ANALYTICAL_MODEL: string = 'ads/analyticalMod/update';
    static SYNC_ANALYTICAL_MODEL: string = 'ads/analyticalMod/sync';
    static DELETE_ANALYTICAL_MODEL: string = 'ads/analyticalMod/delete';
    static PREVIEW_ANALYTICAL_MODEL: string = 'ads/analyticalMod/preview';
    static SYNC_CURRENT_TENANT_PAGE_CACHE: string = '/syncCurrentTenantPageCache';
    static FLUSH_CURRENT_TENANT_PAGE_CACHE: string = '/flushCurrentTenantPageCache';
    static SYNC_CURRENT_TENANT_DATA_VS: string = '/syncCurrentTenantDataVersion';
    static SYNC_CURRENT_TENANT_CUBE_META: string = '/syncCurrentTenantCubeMeta';
    static DATA_POINT: string = 'dataPoint/';
    static ODATA: string = 'OData';
    static RF_ODATA: string = '/getRFDataList';
    static GET_AM_ODATA: string = '/getAMDataList';
    static SAVE_AM_ODATA: string = '/saveAMDataList';
    static REBUILD_DASH_SNAPSHOT: string = 'ads/refreshAllSnapshotDashboards'
}


// WEBPACK FOOTER //
// ./src/app/bi/biUrls.ts